import { useState } from 'react'
import Modal from 'react-modal'
import { useAccount } from 'wagmi'
import { toast } from 'react-toastify'
import { BASE_API_URL } from '../../constants'
import axios from 'axios'
import { useUser } from '../../context'

const customStyles = {
	overlay: {
		backgroundColor: 'rgba(0, 0, 0, 0.7)',
		backdropFilter: 'blur(4px)',
		zIndex: 1000,
	},
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		marginRight: '-50%',
		transform: 'translate(-50%, -50%)',
		background: '#1e1e1e',
		color: '#ffffff',
		borderRadius: '12px',
		padding: '24px',
		border: '1px solid #333',
		boxShadow: '0 10px 30px rgba(0, 0, 0, 0.5)',
		width: '90%',
		maxWidth: '400px',
	},
}

type ModalProps = {
	isOpen: boolean
	onRequestClose: () => void
}

type WithdrawAPIResponse = {
	txHash: string
	blockNumber: number
}

export const WithdrawalModal = ({ isOpen, onRequestClose }: ModalProps) => {
	const { user } = useUser()
	const [amount, setAmount] = useState('')
	const [processing, setProcessing] = useState(false)
	const { address } = useAccount()

	const handleWithdraw = async () => {
		const test = parseFloat(amount)
		if (Number.isNaN(test)) {
			toast('Amount is not valid', {
				type: 'error',
			})
			return
		}

		try {
			setProcessing(true)

			const { data: response } = await axios.post<WithdrawAPIResponse>(
				`${BASE_API_URL}/api/jeeve/withdraw`,
				{
					tgId: user?.tgMetadata?.id,
					amount: amount,
					sourceAddress: user?.dbInfo?.address,
					destinationAddress: address,
				},
			)

			setAmount('')
			toast(`Withdrawal successful. TxHash: ${response.txHash}`, {
				type: 'success',
			})
			setProcessing(false)
			onClose()
		} catch (error) {
			const err = error as any

			let errorMessage = ''
			if (err.name == 'AxiosError') {
				errorMessage = err?.response?.data?.errors?.[0]?.message
			} else {
				errorMessage =
					err?.error?.message ||
					err?.data?.message ||
					err?.reason ||
					err?.message ||
					'Something is not right. Please try again later.'
			}

			toast(`Withdrawal failed. ${errorMessage}`, {
				type: 'error',
			})
			setProcessing(false)
		}
	}

	const onClose = () => {
		if (processing) {
			return
		}

		onRequestClose()
	}

	return (
		<Modal
			isOpen={isOpen}
			onRequestClose={onClose}
			style={customStyles}
			contentLabel="Withdrawal Modal"
		>
			{/* Header */}
			<div
				style={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
					marginBottom: '20px',
				}}
			>
				<h2 style={{ margin: 0, fontSize: '1.5rem' }}>
					Withdraw to wallet
				</h2>
				<button
					onClick={onClose}
					style={{
						background: 'none',
						border: 'none',
						color: '#aaa',
						fontSize: '1.25rem',
						cursor: 'pointer',
					}}
				>
					×
				</button>
			</div>

			{/* Input and Button */}
			<div>
				<p>Enter amount to withdraw</p>
				<input
					disabled={processing}
					type="number"
					placeholder="Enter amount"
					value={amount}
					onChange={(e) => setAmount(e.target.value)}
					style={{
						width: '100%',
						padding: '10px 14px',
						borderRadius: '8px',
						border: '1px solid #444',
						backgroundColor: '#2a2a2a',
						color: '#fff',
						marginTop: '10px',
						marginBottom: '20px',
						fontSize: '1rem',
					}}
				/>
				<button
					disabled={processing}
					onClick={handleWithdraw}
					style={{
						width: '100%',
						padding: '12px',
						backgroundColor: '#4f46e5',
						color: '#fff',
						fontSize: '1rem',
						border: 'none',
						borderRadius: '8px',
						cursor: 'pointer',
					}}
				>
					{processing ? 'Processing...' : 'Withdraw'}
				</button>
			</div>
		</Modal>
	)
}
